'use client';
import React from 'react';
import Slider from 'react-slick';

const TechnicalApproachAiSecurityGovernance: React.FC = () => {
    const technicalapproach = {
        dots: true,
        arrow: true,
        autoplay: false,
        speed: 500, // Set slide transition speed
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1366, // iPad Pro
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };
    return (
        <>
            <section className="section-py case-study relative overflow-hidden">
                <div className="absolute inset-0 z-0">
                    <video playsInline autoPlay muted loop className="aimlvideo w-full h-full object-cover">
                        <source src="media/video-ai-security-governance.mp4" type="video/mp4" />
                    </video>
                    {/* Gradient Overlay */}
                    <div className="absolute inset-0 pointer-events-none bg-video-gradient"></div>
                </div>
                <div className="container lg:container md:mx-auto relative z-[1]">
                    <div className="row grid lg:grid-cols-12 mb-50">
                        <div className="lg:col-span-10">
                            <h2 className="mb-2.5 text-white">
                                How We Build: <span className="gradient-text">Our Technical Approach</span>
                            </h2>
                            <p className="mb-0 fw-600 text-[#D7DEE5]">
                               We follow a structured technical approach to build robust data foundations.
                            </p>
                        </div>
                    </div>

                    <div className="section pb-16 case-study-slider-img case-study-slider-aiml technical-approach-slider aienabled-fintech-slider">
                        <div className="container-fluid lg:container-fluid mx-auto">
                            <Slider {...technicalapproach} data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-discovery-design bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                    Risk Assessment & Discovery
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md">
                                                    Identify AI systems, data flows, compliance needs, security gaps, and governance maturity levels.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-data-preparation bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                    Security Framework Design
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md">
                                                    Define security architecture, access controls, encryption standards, monitoring needs, and incident response protocols.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-rag-architecture bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                   Governance Policy Development
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md">
                                                    Create AI usage policies, approval workflows, risk classification, ethical guidelines, and accountability mechanisms.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-prompt-engineering bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                    Security Controls Implementation
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md">
                                                    Deploy authentication, data encryption, secure APIs, input validation, and threat detection solutions.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-fine-tuning bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                    Monitoring & Detection Setup
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md">
                                                    Establish logging, anomaly detection, bias monitoring, model behavior tracking, and alerting systems.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-integration-testing bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                    Compliance Automation
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md">
                                                   Configure automated compliance checks, audit trail generation, dashboards, and evidence collection.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-integration-testing bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                    Testing & Validation
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md">
                                                   Conduct security testing, red team exercises, compliance audits, bias assessments, and penetration tests.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-integration-testing bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                    Training & Documentation
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md">
                                                   Provide security awareness training, detailed policy documents, incident playbooks, and continuous governance support.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Slider>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
export default TechnicalApproachAiSecurityGovernance;
